import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/connect` — la dirección vieja del alta. Hoy sólo redirige.
 *
 * ── POR QUÉ DEJÓ DE SER UNA PANTALLA ───────────────────────────────────────
 *
 * Era una segunda copia del alta, escrita antes que `/onboarding`, y se quedó
 * atrás: ofrecía el CTA de Gmail SIN consultar `gmail_signup_enabled`. Con la
 * bandera apagada —que es como sale a producción mientras Google evalúa CASA—
 * ese botón mandaba a `/auth/start`, que responde 503 con un JSON: el usuario
 * nuevo terminaba leyendo `{"error":"...","code":"gmail_signup_disabled"}` en
 * el navegador. Esconder el CTA en una pantalla y dejarlo prendido en la otra
 * no es una bandera, es una bandera y una fuga.
 *
 * Tenía además su propia copia de la activación del canal gestionado (un fetch
 * a mano en vez de `ensureManagedMembership()`) y un anuncio con fecha
 * quemada. Dos altas con dos criterios se desincronizan; ésta ya lo había
 * hecho.
 *
 * ── POR QUÉ REDIRIGE EN VEZ DE DESAPARECER ─────────────────────────────────
 *
 * La dirección está pegada en correos ya enviados y en chats de soporte, y
 * ninguno de esos se puede reescribir. `replace` para que "atrás" no rebote
 * entre las dos.
 *
 * La query se conserva entera: `/onboarding` sabe leer `?error=` —incluido
 * `gmail_signup_disabled`— y `?gmail=connected`, así que un enlace viejo con
 * parámetros llega con su mensaje intacto.
 */
export default function JobApplyConnectPage() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/onboarding', search }} replace />;
}
